import React from 'react'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { IconRail, IconRailItem } from '@/design-system'
import WallpaperOutlinedIcon from '@mui/icons-material/WallpaperOutlined'
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined'
import PhotoLibraryOutlinedIcon from '@mui/icons-material/PhotoLibraryOutlined'
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined'
import FilterFramesOutlinedIcon from '@mui/icons-material/FilterFramesOutlined'
import BorderStyleOutlinedIcon from '@mui/icons-material/BorderStyleOutlined'
import { StudioCategory, STUDIO_CATEGORIES } from '../../types'

export interface StudioToolRailProps {
  active: StudioCategory
  onSelect: (category: StudioCategory) => void
}

const ICONS: Record<StudioCategory, React.ReactNode> = {
  template: <WallpaperOutlinedIcon />,
  material: <LayersOutlinedIcon />,
  print: <PhotoLibraryOutlinedIcon />,
  color: <PaletteOutlinedIcon />,
  frame: <FilterFramesOutlinedIcon />,
  matting: <BorderStyleOutlinedIcon />,
}

const Root = styled(Box)({
  width: 88,
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: 'var(--ds-space-4)',
  borderRight: '1px solid var(--ds-border)',
  backgroundColor: 'var(--ds-surface)',
  overflowY: 'auto',
})

/** Left icon-only rail — switches the active property-panel category */
export function StudioToolRail({ active, onSelect }: StudioToolRailProps) {
  const items: IconRailItem[] = STUDIO_CATEGORIES.map((c) => ({
    id: c.id,
    label: c.label,
    icon: ICONS[c.id],
  }))

  return (
    <Root>
      <IconRail items={items} activeId={active} onSelect={(id) => onSelect(id as StudioCategory)} />
    </Root>
  )
}
